var _rect, _mask, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    fill: "#EFF0F4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_301_348",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 14,
    height: 14,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 14,
    height: 14,
    rx: 1,
    fill: "#282B31",
    stroke: "#282B31",
    strokeWidth: 2.3,
    mask: "url(#path-2-inside-1_301_348)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.275 14.235C9.275 13.865 9.34167 13.545 9.475 13.275C9.61167 13.005 9.80667 12.7967 10.06 12.65C10.3133 12.5 10.615 12.425 10.965 12.425C11.3117 12.425 11.6117 12.5 11.865 12.65C12.1183 12.7967 12.3133 13.005 12.45 13.275C12.59 13.545 12.66 13.8633 12.66 14.23C12.66 14.6 12.59 14.9217 12.45 15.195C12.3133 15.465 12.1183 15.675 11.865 15.825C11.6117 15.975 11.3117 16.05 10.965 16.05C10.615 16.05 10.3133 15.975 10.06 15.825C9.81 15.675 9.61667 15.465 9.48 15.195C9.34333 14.9217 9.275 14.6017 9.275 14.235ZM9.95 14.235C9.95 14.6317 10.035 14.9417 10.205 15.165C10.375 15.3883 10.6283 15.5 10.965 15.5C11.2917 15.5 11.5433 15.3883 11.72 15.165C11.8967 14.9417 11.985 14.6317 11.985 14.235C11.985 13.835 11.8967 13.525 11.72 13.305C11.5467 13.085 11.295 12.975 10.965 12.975C10.6283 12.975 10.375 13.085 10.205 13.305C10.035 13.525 9.95 13.835 9.95 14.235ZM13.9407 16V13.005H12.7757V12.475H15.7507V13.005H14.5857V16H13.9407ZM16.2064 16V12.475H17.7714C18.1581 12.475 18.4531 12.5683 18.6564 12.755C18.8597 12.9417 18.9614 13.1983 18.9614 13.525C18.9614 13.8483 18.8597 14.105 18.6564 14.295C18.4531 14.485 18.1581 14.58 17.7714 14.58H16.8514V16H16.2064ZM16.8514 14.07H17.6964C17.9097 14.07 18.0697 14.0233 18.1764 13.93C18.2831 13.8333 18.3364 13.6983 18.3364 13.525C18.3364 13.3517 18.2831 13.2183 18.1764 13.125C18.0697 13.0283 17.9097 12.98 17.6964 12.98H16.8514V14.07Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtp);
export default __webpack_public_path__ + "static/media/otp.bac69e83.svg";
export { ForwardRef as ReactComponent };